import useStreamingText from '@/hooks/cbAi/useStreamingText';
import { useExplorer } from '@/hooks/useExplorer';
import { CodeBlock } from './CodeBlock';
import MarkdownComponent from '../Markdown';
import CodeBlocks from './CodeBlocks';
import APIRecommendations from './APIRecommendations';
import { EndpointExtended } from '@context/openapi/types';
import { UserFeedback } from '@/services/aero/api';

interface GeneratedCodeProps {
  output: string;
  isGenerating: boolean;
  aiResponseOperations: EndpointExtended[];
  showFeedback?: boolean;
  submitFeedback: (feedback: UserFeedback) => Promise<boolean>;
  isStreamFinished?: boolean;
}

const GeneratedCode: React.FC<GeneratedCodeProps> = ({
  output,
  isGenerating,
  aiResponseOperations,
  isStreamFinished = false,
}) => {
  const { aiResponseOperationIds } = useExplorer();

  const { codeBlocks, hasContent } = useStreamingText({
    output,
    MarkdownComponent,
    CodeBlock,
    isGenerating,
    isStreamFinished,
  });

  const renderCodeblocks = (
    <>
      <CodeBlocks codeBlocks={codeBlocks} />
    </>
  );
  const hasEndpoints =
    aiResponseOperationIds && aiResponseOperationIds.length > 0;

  return (
    <>
      {hasContent &&
        (hasEndpoints ? (
          // Display two columns - formatted code and API recommendations
          <>
            <div className="flex flex-row items-start justify-center mx-16 pb-4">
              <div className="w-2/3 px-10 bg-white bg-opacity-50 rounded-2xl py-6">
                {renderCodeblocks}
              </div>

              <div className="ml-8 w-1/3">
                <APIRecommendations endpoints={aiResponseOperations} />
              </div>
            </div>
          </>
        ) : (
          // Display a single code block column
          <>
            <div className="flex flex-row items-start justify-center mx-auto max-w-7xl pb-4">
              <div className="px-10 bg-white bg-opacity-50 rounded-2xl py-6 w-full">
                {renderCodeblocks}
              </div>
            </div>
          </>
        ))}
    </>
  );
};

export default GeneratedCode;
